import { Routes } from 'react-router-dom'

import GameRoutes from './modules/game/Routes'
import QuestRoutes from './modules/game/quests/Routes'

export default <Routes>{[GameRoutes, QuestRoutes]}</Routes>
